import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

const periodValues = [{ key: 'Q1' }, { key: 'Q2' }, { key: 'Q3' }, { key: 'Q4' }]
export const periodCrud = new Crud({
  fetcher: new Static(periodValues.sort((a, b) => a.key.localeCompare(b.key))),
  keyField: 'key',
  defaultPaging: {
    page: 0,
    pageSize: periodValues.length,
  },
})
